// Public privacy policy page (rendered at /privacy, no auth required).
//
// This page must satisfy A2P 10DLC / carrier requirements for the SMS campaign:
//   - explicit non-sharing statement for mobile numbers + SMS consent
//   - message frequency disclosure
//   - "message and data rates may apply" disclosure
// Do not remove those clauses without updating the Twilio campaign registration.

const EFFECTIVE = 'July 27, 2026';

export default function PrivacyPolicy() {
  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">🦅 Eagle Ridge Outdoor Club</div>
        <a className="topbar-link" href="/">Home</a>
      </header>
      <main className="content legal">
        <div className="card">
          <h1>Privacy Policy</h1>
          <p className="muted">Effective {EFFECTIVE}</p>

          <p>
            Eagle Ridge Outdoor Club ("Eagle Ridge," "we," "us") operates the
            member portal at eagleridgeclub.com. This policy explains what
            information we collect, how we use it, and your choices.
          </p>

          <h2>Information we collect</h2>
          <ul>
            <li>Account and identity information you provide when you accept an invitation and sign in (name, email address).</li>
            <li>Contact details you choose to add, including your mobile phone number, and your communication preferences (email and SMS opt-in).</li>
            <li>Membership, reservation, and community board activity within the portal.</li>
          </ul>

          <h2>How we use your information</h2>
          <ul>
            <li>To operate the club: manage your membership, reservations, and access to community boards.</li>
            <li>To communicate with you: send club announcements, operational updates, and reminders by email and, if you opt in, by text message (SMS).</li>
            <li>To keep the portal secure and functioning.</li>
          </ul>

          <h2>SMS / text messaging</h2>
          <p>
            If you opt in to text messages, you will receive informational club
            announcements and updates. <strong>Message frequency varies and is
            expected to be a few messages per month.</strong> <strong>Message and
            data rates may apply.</strong> You can opt out at any time by replying
            STOP to any message, and reply HELP for help. You may also manage your
            SMS opt-in from your account profile.
          </p>
          <p>
            <strong>We do not sell, rent, or share your mobile phone number or your
            SMS consent with any third parties or affiliates for their marketing or
            promotional purposes.</strong> Mobile information is used solely to
            deliver the club communications you have requested. Text messaging
            originator opt-in data and consent are not shared with any third
            parties.
          </p>

          <h2>How we share information</h2>
          <p>
            We share information only with service providers that help us operate
            the portal (for example, our authentication, hosting, email, and SMS
            delivery providers), and only to the extent needed to provide those
            services. We do not sell your personal information. We may disclose
            information if required by law.
          </p>

          <h2>Data retention and security</h2>
          <p>
            We retain your information for as long as your membership is active or
            as needed to operate the club, and we use reasonable safeguards to
            protect it.
          </p>

          <h2>Your choices</h2>
          <p>
            You can update your contact details and opt out of email or SMS
            communications at any time from your account profile, or by replying
            STOP to any text message.
          </p>

          <h2>Contact us</h2>
          <p>
            Questions about this policy? Contact Eagle Ridge Outdoor Club, Corinth,
            Kentucky, at <a href="mailto:privacy@eagleridgeclub.com">privacy@eagleridgeclub.com</a>.
          </p>

          <p className="muted"><a href="/terms">Terms of Service</a> · <a href="/">Return to portal</a></p>
        </div>
      </main>
      <footer className="footer"><span>Corinth, Kentucky</span></footer>
    </div>
  );
}
